import React, { useState } from 'react';
import { AccordionData } from './AccordionData';

function AccordionUrl() {
  const [faq, setFaq] = useState(AccordionData);

  const toggleAccordion = (index: number) => {
    // Create a copy of the FAQ array
    const updatedFaq = [...faq];
  
    // Check if the clicked question is already open
    if (updatedFaq[index].isActive) {
      // If it's already open, close it
      updatedFaq[index].isActive = false;
    } else {
      // If it's closed, close all previously opened questions and then open the clicked one
      updatedFaq.forEach((item) => (item.isActive = false));
      updatedFaq[index].isActive = true;
    }
  
    setFaq(updatedFaq);
  };

  return (
    <>
      <section className="important-urls">
        <div className="container">
          <div className="row faq_wrap">
            <div className="col-md-12 right">
              <ul>
                {faq.map((item, index) => (
                  <li key={index}>
                    <div
                      className={`question ${item.isActive ? 'active' : ''}`}
                      onClick={() => toggleAccordion(index)}
                    >
                      {item.question}{' '}
                      {/* <i
                        className={`fa ${
                          item.isActive ? 'fa-angle-up' : 'fa-angle-down'
                        }`}
                      ></i> */}
                    </div>
                    {item.isActive && (
                      <div className="answer-new">
                        <div className="myList">
                          {item.content.map((contentItem, contentIndex) => (
                            <div key={contentIndex} className="cityURL">
                              <a className="mylistcolor" href={contentItem.url}>
                                {contentItem.answer}
                              </a>
                              <br />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AccordionUrl;